<template>
  <div class="body_container">
    <Contact></Contact>
    <div class="width_margin">
      <div class="container_content_list_title">맞춤컨설팅</div>
    </div>

    <div class="width_margin">
      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication45.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#맞춤 콘텐츠</div>
            </div>
          </div>
        </div>
        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              자사 맞춤 콘텐츠 개발
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            특화된 맞춤 콘텐츠로 고도화 하여 전략적으로 현업 대상자에게 직무
            솔루션을 제공합니다.
          </div>
          <div class="container_content_text_content">
            계층별, 목적별, 직무별 니즈에 따라 자사 맞춤형 콘텐츠를 교육 전파에
            적합한 형태로 개발이 필요한 기업에게 적합<br />
            핵심가치, 조직문화, CEO 메시지, 주요 글로벌 사업 현황 및 노하우 공유
            등 시중 교재나 내용에 없는 자사 맞춤형 콘텐츠<br />
            출판 형태, 마이크로러닝 동영상 형태, 에듀테크를 활용한 다양한 플랫폼
            선택 가능, 자사 맞춤 평가까지 총 5500종의 콘텐츠 개발 노하우
          </div>
        </div>
      </div>
      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication47.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">#자사 매뉴얼</div>
            </div>
          </div>
        </div>
        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              자사 사례 DB화 및 매뉴얼 개발
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            자사 고유의 글로벌 주재원 및 이문화 경험 사례 등을 DB화하여 교육
            자료화 할 수 있도록 제작해 드립니다.
          </div>
          <div class="container_content_text_content">
            글로벌 실제 사례를 발췌, 연구하여 지식들이 조직차원에서 현업 적용할
            수 있는 자사만의 콘텐츠 DB화<br />
            실무 및 현지 사례, 국가별 이문화 갈등 사례 등을 접목, 이문화와 조직
            문화를 결합한 Case study 가능<br />
            110개국 이상 국가별 데이터 베이스를 기반으로 직원들의 경험과
            노하우를 매뉴얼화 추진<br />
          </div>
        </div>
      </div>
      <div class="container_content_list">
        <div class="container_content_list_img">
          <img src="@/assets/img/global/sub_page_communication48.png" />
          <div class="container_content_list_box">
            <div class="container_content_list_img_text">
              <div class="container_content_list_left_icon"></div>
              <div class="container_content_list_right_text">
                #역량체계 컨설팅
              </div>
            </div>
          </div>
        </div>
        <div class="container_content_text_list">
          <div class="container_content_text_title_down_container">
            <div class="container_content_text_title1">
              글로벌 역량체계 수립 컨설팅
            </div>
            <!-- <div class="container_content_download"><img class="container_right_download_img" src="@/assets/img/global/sub_page_down_img.png" />Download</div> -->
          </div>
          <div class="container_content_text_title">
            컨설팅 프로세스를 통해 자사 현황에 최적화된 글로벌 역량체계를
            수립하도록 다양한 분석과 최신 사례를 바탕으로 글로벌 역량 수준을
            향상시키는 데 기여합니다.
          </div>
          <div class="container_content_text_content">
            글로벌 역량 체계를 확립하여 연간 평가 체계, 연간 교육 체계를
            수립하여 보다 효율적인 글로벌 역량을 실천하는 것이 목적<br />
            글로벌 역량 강화 교육 및 평가에 대한 전반적인 현황 점검, 현황진단 및
            수요조사, 역량 모델링 등 사전 분석, 교육 및 평가체계 수립 등<br />
            500여개 프로젝트, 25,000개 콘텐츠 데이터베이스 구축 경험을 바탕으로
            하는 글로벌 역량 체계 수립 컨설팅 프로젝트
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Global/ContactUs.vue";
export default {
  components: {Contact},
  name: "Consulting",
};
</script>

<style></style>
